<template>
  <bean-source-page :type="type" :columns="columns" :form-columns="formColumns" :filter-columns="filterColumns"
    :actions="actions" :form="form" :tabs="tabs" :title="$t('model.productDesign')" :batch-actions="batchActions"
    ref="sourcePage" :onFetchData="onFetchData" resource="product_designs" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/product_designs.js';
import { columnsExtend as productDesignItemColumnsExtend } from '../admin_entities/product_design_item_detail.js';
import RejectFormDialog from './orders/reject.vue';
import { getLabel } from '@/custom_form_columns_extend';
import { abilityService } from 'beans-admin-plugin';
import { DialogFormButton } from 'beans-admin-plugin/components/column-render.vue'
import _ from 'lodash';
import moment from 'moment';
import { FILE_ACCEPT, FILE_TYPE, PRODUCT_DESIGN_VIRTUAL_STATES } from '@/constants';
import QRCode from '@/components/qrcode.vue';
import JSZip from 'jszip';
import CareLabel from '@/components/care-label/index.vue';
import PrintProductDesignImage from '@/components/print-product-design-image.vue';

@Component({
  components: { QRCode, PrintProductDesignImage }
})
export default class ProductDesigns extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  record = {}
  form = {}
  salesDirectorRejectReasons = [];
  makePlateRejectReasons = [];
  cheifPatternMakingOfficierRejectReasons = []
  cutRejectReasons = []
  sewRejectReasons = []
  companies = []
  user = {}

  get tabs() {
    return [
      {
        label: this.$t('model.productDesign'),
        columns: this.columns(this.$createElement, { type: 'show' })
      },
      {
        label: this.$t('model.operationLog'),
        renderCell: (h, value) => {
          const operationLogsTable = (name, operationLogs) => {
            return <el-table style={{ marginBottom: '20px' }} data={operationLogs}>
              <el-table-column label={name}>
                <el-table-column
                  prop="created_at"
                  label="操作时间"
                  scopedSlots={{
                    default: (scope) => {
                      const createdAt = operationLogs[scope.$index].created_at

                      return moment(createdAt).format('YYYY-MM-DD HH:mm:ss')
                    }
                  }}
                />
                <el-table-column
                  prop="operator"
                  label="操作人"
                  scopedSlots={{
                    default: (scope) => {
                      const operator = operationLogs[scope.$index].operator

                      if (operator) {
                        return <bean-link keepNode to={{ name: 'users.show', params: { id: operator.id } }}>{operator.profile.name}</bean-link>
                      } else {
                        return <span>系统</span>
                      }
                    }
                  }}
                />
                <el-table-column prop="event_description" label="事件" />
                <el-table-column
                  prop="detail"
                  label="详情"
                  scopedSlots={{
                    default: (scope) => {
                      const detail = operationLogs[scope.$index].detail

                      return <span style="white-space: pre-wrap; word-break: break-all">{detail}</span>
                    }
                  }}

                />
                <el-table-column
                  prop="time_consuming"
                  label="耗时（秒）"
                  scopedSlots={{
                    default: (scope) => {
                      const timeConsuming = operationLogs[scope.$index].time_consuming

                      if (timeConsuming) {
                        return <span>{timeConsuming}</span>
                      } else {
                        return <span>-</span>
                      }
                    }
                  }}
                />
                <el-table-column
                  prop="time_consuming_hour"
                  label="耗时（小时）"
                  scopedSlots={{
                    default: (scope) => {
                      const timeConsuming = operationLogs[scope.$index].time_consuming

                      if (timeConsuming) {
                        return <span>{(timeConsuming / 3600).toFixed(2)}</span>
                      } else {
                        return <span>-</span>
                      }
                    }
                  }}
                />
              </el-table-column>
            </el-table>
          }

          const exportOperationLogs = async (productDesign) => {
            const options = { timeout: 30 * 60 * 1000, responseType: 'blob', return_res: true }
            const result = await this.$autoLoading(this.$request.get(`/product_designs/${productDesign.id}/export_operation_logs`, {}, options))
            const blob = new Blob([result.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `服装制单-${productDesign.number}操作日志.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }

          return (
            <div class="operation-logs">
              <el-button
                type="primary"
                size="small"
                style="margin-bottom: 10px;"
                onClick={() => exportOperationLogs(value)}
              >
                导出
              </el-button>
              {operationLogsTable('服装制单', _.get(value, 'operation_logs', []))}
              {/* {operationLogsTable('服装制单', _.get(value, 'state_operation_logs', []))} */}
              {/* {operationLogsTable('服装制单面料', _.get(value, 'fabric_state_operation_logs', []))} */}
              {/* {operationLogsTable('服装制单辅料', _.get(value, 'accessory_state_operation_logs', []))} */}
              {/* {operationLogsTable('服装制单普通操作', _.get(value, 'normal_operation_logs', []))} */}
            </div>
          )
        }
      },
    ]
  }

  async mounted() {
    const roleKind = _.get(this.$root.user, 'current_role.role.kind');

    if (['sales_director'].includes(roleKind)) {
      const data = await this.$request.get('/reject_reasons/read_options', { kind_eq: 'sales_director_reject_product_design', page: 0 });

      this.salesDirectorRejectReasons = data
    }

    if (['cheif_pattern_making_officier', 'pattern_maker'].includes(roleKind)) {
      this.makePlateRejectReasons = (await this.$request.get('/reject_reasons/read_options', { kind_eq: 'reject_product_design_make_plate', page: 0 }));
    }

    if (['cheif_pattern_making_officier'].includes(roleKind)) {
      this.cheifPatternMakingOfficierRejectReasons = (await this.$request.get('/reject_reasons/read_options', { kind_eq: 'cheif_pattern_making_officier_reject_product_design', page: 0 }));
    }

    if (['cheif_pattern_making_officier', 'craftsman'].includes(roleKind)) {
      this.cutRejectReasons = (await this.$request.get('/reject_reasons/read_options', { kind_eq: 'reject_product_design_cut', page: 0 }));
    }

    if (['cheif_pattern_making_officier'].includes(roleKind)) {
      this.sewRejectReasons = (await this.$request.get('/reject_reasons/read_options', { kind_eq: 'reject_product_design_sew', page: 0 }));
    }
  }

  get productDesignItemFormColumns() {
    return [
      {
        prop: 'color',
        label: this.$t('productDesignItem.colorOptionValueId'),
        renderCell: {
          component: 'select',
          required: true,
          props: {
            allowCreate: true,
            defaultFirstOption: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/option_values/read_options', { per_page: 100, option_type_kind_eq: 'color' });
              return data.map(item => ({ value: item.name, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/option_values/read_options', { keyword, option_type_kind_eq: 'color' });
              return data.map(item => ({ value: item.name, label: item.name }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        prop: 'size_option_value_id',
        label: this.$t('productDesignItem.sizeOptionValueId'),
        renderCell: {
          component: 'select',
          required: true,
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/option_values/read_options', { per_page: 100, option_type_kind_eq: 'size' });
              return data.map(item => ({ value: item.id, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/option_values/read_options', { keyword, option_type_kind_eq: 'size' });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        prop: 'quantity',
        label: this.$t('productDesignItem.quantity'),
        renderCell: {
          component: 'inputNumber',
          required: true,
        }
      }
    ];
  }

  usersSelectProps({ item, query }) {
    const v = { extra: { model_name: 'User' } }
    let hash = {
      xRemotePreload: async () => {
        const { data } = await this.$request.get('users/read_options', { per_page: 100, is_block_eq: false, ...query });
        return data.map(object => ({ value: object.id, label: getLabel({ item: object, v: v }) }));
      },
      xRemoteSearch: async (keyword) => {
        const { data } = await this.$request.get('users/read_options', { keyword, is_block_eq: false, ...query });
        return data.map(object => ({ value: object.id, label: getLabel({ item: object, v: v }) }));
      }
    }

    if (item) {
      hash.options = [{ value: item['id'], label: getLabel({ item, v: v }) }]
    }

    return hash
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const roleKind = _.get(this.$root.user, 'current_role.role.kind');
    let stateInFilter = {
      prop: 'state_in',
      label: this.$t('productDesign.state'),
      renderCell: {
        component: 'select',
        attrs: {
          collapseTags: true,
        },
        props: {
          multiple: true,
          options: _.map(PRODUCT_DESIGN_VIRTUAL_STATES, (state) => ({ label: this.$t(`productDesign.states.${state}`), value: state }))
        }
      }
    }

    if (['salesman', 'sales_director'].includes(roleKind)) {
      stateInFilter = {
        prop: 'state_in',
        label: this.$t('productDesign.state'),
        renderCell: {
          component: 'select',
          props: {
            multiple: true,
            options: [
              { label: this.$t('productDesign.states.init'), value: 'init' },
              { label: this.$t('productDesign.states.wait_sales_director_audit'), value: 'wait_sales_director_audit' },
              { label: this.$t('productDesign.states.sales_director_rejected'), value: 'sales_director_rejected' },
              { label: this.$t('productDesign.states.pending'), value: 'pending' },
              { label: '制作中', value: 'processing' },
              { label: this.$t('productDesign.states.completed'), value: 'completed' },
            ]
          }
        }
      }
    }

    const array = [
      {
        prop: 'keyword',
        label: '关键词',
        renderCell: {
          component: 'input',
        }
      },
      [
        'cheif_pattern_making_officier',
        'pattern_maker',
        'craftsman',
        'sewer',
        'purchaser',
        'valuer',
      ].includes(roleKind) && {
        prop: 'audited_on_eq',
        label: '版房总监审核',
        renderCell: {
          component: 'datePicker',
          props: {
            type: 'date',
          }
        }
      },
      'number_cont',
      'plate_making_type_eq',
      'design_type_eq',
      {
        prop: 'overdue_state',
        label: this.$t('productDesign.publicationOn'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [{ label: '未逾期', value: 'no_overdue' }, { label: '已逾期', value: 'overdue' }, { label: '按时交版', value: 'on_time' }, { label: '提前交版', value: 'in_advance' }]
          }
        }
      },
      stateInFilter,
      {
        key: 'fabric_state_in',
        renderCell: {
          props: {
            multiple: true
          },
          attrs: {
            collapseTags: true,
          },
        }
      },
      {
        key: 'accessory_state_in',
        renderCell: {
          props: {
            multiple: true
          },
          attrs: {
            collapseTags: true,
          },
        }
      },
      {
        key: 'designer_id_eq',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            filterable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/users/read_options', { role_in: ['designer', 'salesman', 'sales_director'], is_block_eq: false, per_page: 100 });
              return data.map(({ id, profile }) => ({ value: id, label: profile.name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { role_in: ['designer', 'salesman'], keyword: keyword, per_page: 100 };
              const { data } = await this.$request.get('/users/read_options', params);
              return data.map(({ id, profile }) => ({ value: id, label: profile.name }));
            }
          }
        }
      },
      {
        key: 'cheif_pattern_making_officier_id_eq',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            filterable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/users/read_options', { role_in: ['cheif_pattern_making_officier'], is_block_eq: false, per_page: 100 });
              return data.map(({ id, profile }) => ({ value: id, label: profile.name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { role_in: ['designer', 'salesman'], keyword: keyword, per_page: 100 };
              const { data } = await this.$request.get('/users/read_options', params);
              return data.map(({ id, profile }) => ({ value: id, label: profile.name }));
            }
          }
        }
      },
      {
        key: 'supplier_id_eq',
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            filterable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/users/read_options', { role_in: ['supplier', 'supplier_boss'], is_block_eq: false, is_cheif_pattern_making_officier_eq: true, per_page: 100 });
              return data.map(({ id, profile }) => ({ value: id, label: profile.name }));
            },
            xRemoteSearch: async (keyword) => {
              const params = { role_in: ['supplier', 'supplier_boss'], keyword: keyword, is_cheif_pattern_making_officier_eq: true, per_page: 100 };
              const { data } = await this.$request.get('/users/read_options', params);
              return data.map(({ id, profile }) => ({ value: id, label: profile.name }));
            }
          }
        }
      },
      'pattern_maker_id_eq',
      'pattern_factory_eq',
      abilityService.can('companies.read_options') && {
        key: 'company_id_in',
        renderCell: {
          props: {
            multiple: true,
          }
        }
      },
      [
        'salesman',
        'sales_director',
        'merchandiser',
        'application',
      ].includes(roleKind) && {
        prop: 'date_range_between',
        label: '时间段',
        renderCell: {
          component: 'datePicker',
          props: {
            type: 'daterange',
            rangeSeparator: '至',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      type === 'index' && {
        prop: 'main_image',
        label: '主图',
        width: 120,
        renderCell: 'storageAttachment',
      },
      { key: 'number', minWidth: 100 },
      'plate_making_type',
      {
        key: 'publication_on',
        minWidth: 220,
        renderCell(h, { props: { value, scope: { row } } }) {
          return (
            <div>
              <div>{value}</div>
              <div>{row.overdue_state}</div>
              <div>{row.plan_completed_on ? `计划完成日期：${moment(row.plan_completed_on).format('YYYY-MM-DD')}` : null }</div>
            </div>
          )
        }
      },
      'design_type',
      'customer_name',
      {
        key: 'pattern_factory',
        width: 110,
      },
      {
        prop: 'product_design_item_table_attributes',
        label: this.$t('model.productDesignItem'),
        type: 'expand',
        width: 100,
        renderCell: (h, { props: { value } }) => {
          const productDesignItemColumns = productDesignItemColumnsExtend([
            { key: 'color_option_value', label: this.$t('productDesignItem.colorOptionValueId') },
            { key: 'size_option_value', label: this.$t('productDesignItem.sizeOptionValueId') },
            { key: 'quantity', label: this.$t('productDesignItem.quantity') },
          ])
          return <bean-table style={{ width: '800px' }} value={value} columns={productDesignItemColumns} />;
        }
      },
      type === 'show' && {
        key: 'images',
        width: 120,
        renderCell: (h, { props: { value: attachments, scope: { row } } }) => {
          return (
            <div class={'flex'} style={{ flexWrap: 'wrap', gap: '10px' }} onClick={e => e.stopPropagation()}>
              {
                attachments.map((attachment, index) => {
                  if (!attachment.content_type) return;
                  const previewSrcList = attachments.slice(index, attachments.length).concat(attachments.slice(0, index)).
                      filter((attachment) => { return attachment.content_type.match(/image/) }).
                      map((attachment) => { return attachment.url });
                  const imageProps = { previewSrcList, fit: 'contain' };
                  return (
                    <div class={'flex column'}>
                      <bean-admin-resource-render
                        imageProps={imageProps}
                        value={attachment}
                        key={index}
                      />

                      <PrintProductDesignImage
                        attachment={attachment}
                        productDesign={row}
                        currentUser={this.user}
                      />
                    </div>
                  )
                })
              }
            </div>
          )
        }
      },
      'pattern_type',
      { key: 'remark', minWidth: 120 },
      type === 'show' && 'cheif_pattern_making_officier_remark',
      type === 'show' && 'overdue_reason',
      type === 'show' && 'reject_reason',
      {
        key: 'state',
        minWidth: 130
      },
      {
        key: 'fabric_state',
        minWidth: 130
      },
      {
        key: 'accessory_state',
        minWidth: 130
      },
      'sales_director_audited_at',
      'audited_at',
      'confirmed_at',
      'completed_at',
      type === 'show' && {
        key: 'cost_price',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return (
            <div>
              <el-collapse>
                <el-collapse-item title={value}>
                  <div>
                    <div>{this.$t('productDesign.fabricCost')}: {row.fabric_cost}</div>
                    <div>{this.$t('productDesign.assistCost')}: {row.assist_cost}</div>
                    <div>{this.$t('productDesign.craftCost')}: {row.craft_cost}</div>
                    <div>{this.$t('productDesign.processingCost')}: {row.processing_cost}</div>
                    {row.management_cost && (
                      <div>
                        {this.$t('productDesign.managementCost')}: {row.management_cost}
                      </div>
                    )}
                    <div>{this.$t('productDesign.fobProfit')}: {row.fob_profit}</div>
                    <div>{this.$t('productDesign.managementFee')}: {row.management_fee}</div>
                    <div>{this.$t('productDesign.inspectionFee')}: {row.inspection_fee}</div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div style={{ marginTop: '10px' }}>
                {row.abilities.edit_cost && h(DialogFormButton, {
                  props: {
                    label: '修改',
                    type: 'primary',
                    size: 'mini',
                    value: {
                      fabric_cost: row.fabric_cost,
                      assist_cost: row.assist_cost,
                      craft_cost: row.craft_cost,
                      processing_cost: row.processing_cost,
                      fob_profit: row.fob_profit,
                      management_fee: row.management_fee,
                      inspection_fee: row.inspection_fee,
                      ...(row.management_cost && { management_cost: row.management_cost })
                    },
                    columns: formColumnsExtend([
                      'fabric_cost',
                      'assist_cost',
                      'craft_cost',
                      'processing_cost',
                      ...(row.management_cost ? ['management_cost'] : []),
                      'fob_profit',
                      'management_fee',
                      'inspection_fee',
                    ], { data: row }),
                    submitHandler: async (value) => {
                      await this.$autoLoading(this.$request.put(`/product_designs/${row.id}`, value));
                      this.$message.success(this.$t('operateSuccess'));
                      this.$refs.sourcePage.fetchData();
                    }
                  },
                })}
              </div>
            </div>
          )
        }
      },
      type === 'show' && {
        key: 'settlement_cost',
        renderCell: (h, { props: { value, scope: { row } } }) => {
          return (
            <el-collapse>
              <el-collapse-item title={value}>
                <div>
                  <div>{this.$t('productDesign.fabricSettlementCost')}: {row.fabric_settlement_cost}</div>
                  <div>{this.$t('productDesign.assistSettlementCost')}: {row.assist_settlement_cost}</div>
                  <div>{this.$t('productDesign.craftSettlementCost')}: {row.craft_settlement_cost}</div>
                  <div>{this.$t('productDesign.processingSettlementCost')}: {row.processing_settlement_cost}</div>
                  <div>{this.$t('productDesign.managementSettlementCost')}: {row.management_settlement_cost}</div>
                </div>
              </el-collapse-item>
            </el-collapse>
          )
        }
      },

      type === 'show' && 'completed_remark',
      type === 'show' && 'plan_completed_remark',
      type === 'show' && this.record.pattern_factory !== 'pattern' && 'receive_pattern_on',
      type === 'show' && this.record.pattern_factory !== 'pattern' && 'receive_pattern_remark',
      type === 'show' && 'confirm_fabric_remark',
      type === 'show' && 'confirm_fabric_remark_images',
      type === 'show' && 'receive_fabric_on',
      type === 'show' && 'receive_fabric_remark',
      type === 'show' && 'receive_fabric_remark_images',
      type === 'show' && 'confirm_accessory_remark',
      type === 'show' && 'confirm_accessory_remark_images',
      type === 'show' && 'receive_fabric_and_assist_on',
      type === 'show' && 'receive_fabric_and_assist_remark',
      type === 'show' && 'receive_fabric_and_assist_remark_images',
      type === 'show' && 'make_plate_remark',
      type === 'show' && 'make_plate_remark_images',
      type === 'show' && 'complete_make_plate_remark',
      type === 'show' && 'complete_make_plate_remark_images',
      type === 'show' && 'cut_remark',
      type === 'show' && 'cut_remark_images',
      type === 'show' && 'process_start_on',
      type === 'show' && 'process_remark',
      type === 'show' && 'process_remark_images',
      type === 'show' && 'complete_craft_remark',
      type === 'show' && 'complete_craft_remark_images',
      type === 'show' && 'sewing_start_on',
      type === 'show' && 'sewing_remark',
      type === 'show' && 'sewing_remark_images',
      type === 'show' && 'complete_sewing_remark',
      type === 'show' && 'complete_sewing_remark_images',
      type === 'show' && 'approve_plate_remark',
      type === 'show' && 'approve_plate_remark_images',
      type === 'show' && 'audit_quantity_remark',
      type === 'show' && 'company',
      {
        key: 'designer',
        width: 130,
      },
      'cheif_pattern_making_officier',
      {
        key: 'supplier',
        width: 130,
      },
      'pattern_maker',
      'purchaser',
      'craftsman',
      'sewer',
      'valuer',
      type === 'index' && { key: 'completed_remark', minWidth: 120 },
      type === 'show' && 'files',
      type === 'show' && _.has(this.record, 'paper_pattern_files') && 'paper_pattern_files',
      type === 'show' && _.has(this.record, 'cost_detail_files') && 'cost_detail_files',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type, change }) {
    const roleKind = _.get(this.$root.user, 'current_role.role.kind');
    const abilities = _.get(data, 'abilities', {
      edit_columns: true,
      edit_publication_on: true,
      edit_designer_id: roleKind === 'application',
      edit_company_id: true,
      edit_files: ['designer', 'salesman', 'sales_director', 'application'].includes(roleKind),
      edit_images: true,
      edit_remark: true
    });

    const fileRenderCell = {
      props: {
        accept: FILE_ACCEPT,
        type: FILE_TYPE,
        size: 2048,
      }
    }

    const array = [
      abilities.edit_columns && 'number',
      abilities.edit_columns && {
        key: 'pattern_factory',
        renderCell: {
          on: {
            change: async (value) => {
              // 目前只有创建的时候可以选择版房类型
              if (type === 'new') {
                if (value) {
                  this.companies = (await this.$request.get('companies/read_options', { per_page: 999, users_pattern_factory_eq: value })).data
                } else {
                  this.companies = []
                }

                change({ company_id: null })
              }
            }
          }
        }
      },
      abilities.edit_columns && 'plate_making_type',
      abilities.edit_columns && 'design_type',
      abilities.edit_columns && data.design_type === 'custom' && 'customer_name',
      abilities.edit_designer_id && {
        key: 'designer_id',
        renderCell: {
          required: true,
          props: this.usersSelectProps({ item: data.designer, query: { role_in: ['designer', 'salesman', 'sales_director'] } })
        }
      },
      abilities.edit_publication_on && 'publication_on',
      abilities.edit_columns && {
        prop: 'product_design_item_table_attributes',
        label: this.$t('model.productDesignItem'),
        renderCell: {
          component: 'nestForm',
          props: {
            columns: this.productDesignItemFormColumns
          }
        }
      },
      abilities.edit_columns && 'pattern_type',
      abilities.edit_remark && 'remark',
      abilities.edit_images && {
        key: 'images',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 300x300`,
          props: {
            size: 20,
            limit: 9,
            cropper: {
              width: 300,
              height: 300,
            }
          }
        }
      },
      ((type === 'new' && data.pattern_factory) || (type === 'edit' && abilities.edit_company_id)) && {
        key: 'company_id',
        renderCell: {
          component: 'select',
          required: true,
          props: {
            clearable: true,
            options: _.map(this.companies, (company) => ({ label: company.name, value: company.id })),
            xRemotePreload: () => {
              return this.companies.map(item => ({ value: item.id, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              this.companies = (await this.$request.get('companies/read_options', { keyword, per_page: 999, users_pattern_factory_eq: data.pattern_factory })).data;

              return this.companies.map(item => ({ value: item.id, label: item.name }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      // abilities.edit_cost && 'fabric_cost',
      // abilities.edit_cost && 'assist_cost',
      // abilities.edit_cost && 'craft_cost',
      // abilities.edit_cost && 'processing_cost',
      // abilities.edit_cost && 'management_cost',
      abilities.edit_settlement_cost && 'fabric_settlement_cost',
      abilities.edit_settlement_cost && 'assist_settlement_cost',
      abilities.edit_settlement_cost && 'craft_settlement_cost',
      abilities.edit_settlement_cost && 'processing_settlement_cost',
      abilities.edit_settlement_cost && 'management_settlement_cost',
      abilities.edit_completed_remark && 'completed_remark',
      abilities.edit_cheif_pattern_making_officier_remark && 'cheif_pattern_making_officier_remark',
      abilities.edit_files && {
        key: 'files',
        renderCell: fileRenderCell
      },
      abilities.edit_paper_pattern_files && {
        key: 'paper_pattern_files',
        renderCell: fileRenderCell
      },
      abilities.edit_cost_detail_files && {
        key: 'cost_detail_files',
        renderCell: fileRenderCell
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const roleKind = _.get(this.$root.user, 'current_role.role.kind');
    const abilities = _.get(row, 'abilities', {});
    const needCostPriceInput = ['original', 'reproduction', 'pre_production', 'fabric_craft'].includes(row.plate_making_type);

    return ([
      abilities.update && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'product_designs.edit', params: { id: row.id } }
        }
      },
      {
        component: () => <QRCode url={`${this.$root.user.host}/pages/product-designs-qrcode/detail?id=${row.id}`} />,
        props: {
          label: '二维码',
          type: 'primary'
        },
      },
      {
        component: () => <CareLabel data={row} />,
        props: {
          label: '打印洗水唛',
          type: 'primary'
        },
      },
      abilities.submit && {
        component: 'confirmButton',
        props: {
          label: '提交审核',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/submit`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      abilities.withdraw && {
        component: 'confirmButton',
        props: {
          label: '撤回申请',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/withdraw`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.can_sales_director_approve && {
        component: 'confirmButton',
        props: {
          label: '同意',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/sales_director_approve`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.can_sales_director_withdraw && {
        component: 'confirmButton',
        props: {
          label: '撤回审核',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/sales_director_withdraw`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.can_sales_director_reject && (
        () => <RejectFormDialog data={row} rejectReasons={this.salesDirectorRejectReasons} submitHandler={async (value) => {
          await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/sales_director_reject`, value));
          this.$message.success(this.$t('operateSuccess'));
          reload();
        }} />
      ),
      ['making', 'wait_confirm', 'wait_make_plate_confirm', 'making_plate'].includes(row.state) && {
        component: 'dialogFormButton',
        props: {
          label: '变更跟版员',
          can: 'product_designs.application_update',
          columns: formColumnsExtend([
            {
              key: 'pattern_maker_id',
              renderCell: {
                required: true,
                props: {
                  clearable: true,
                  options: row.pattern_maker_id ? [{ label: row.pattern_maker.profile.name, value: row.pattern_maker_id }] : [],
                  xRemotePreload: async () => {
                    const { data } = await this.$request.get('/users', { per_page: 100, pattern_maker_with_product_design_id: row.id, is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  },
                  xRemoteSearch: async (keyword) => {
                    const { data } = await this.$request.get('/users', { keyword, pattern_maker_with_product_design_id: row.id, is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  }
                },
              }
            },
          ], { data: row, type: 'edit' }),
          value: row,
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/application_update`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      // (row.product_design_item_table_attributes.length === 0 || row.state !== 'finished') && {
      //   component: 'dialogFormButton',
      //   props: {
      //     label: `${this.$t('edit')}${this.$t('model.productDesignItem')}`,
      //     can: 'product_designs.application_update',
      //     value: row,
      //     columns: [
      //       {
      //         prop: 'product_design_item_table_attributes',
      //         label: this.$t('model.productDesignItem'),
      //         renderCell: {
      //           component: 'nestForm',
      //           props: {
      //             columns: this.productDesignItemFormColumns
      //           }
      //         }
      //       }
      //     ],
      //     submitHandler: async (value) => {
      //       await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/update_product_design_items`, value));
      //       this.$message.success(this.$t('operateSuccess'));
      //       reload();
      //     }
      //   }
      // },
      row.can_complete && {
        component: 'dialogFormButton',
        props: {
          label: '完成订单',
          value: row,
          columns: formColumnsExtend([
            needCostPriceInput && 'fabric_cost',
            needCostPriceInput && 'assist_cost',
            needCostPriceInput && 'craft_cost',
            needCostPriceInput && 'processing_cost',
            needCostPriceInput && 'fob_profit',
            needCostPriceInput && 'management_fee',
            needCostPriceInput && 'inspection_fee',
            ...(needCostPriceInput && row.management_cost ? ['management_cost'] : []),
            'completed_remark',
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/complete`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.can_reject && (
        () => <RejectFormDialog data={row} rejectReasons={this.cheifPatternMakingOfficierRejectReasons} submitHandler={async (value) => {
          await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/reject`, value));
          this.$message.success(this.$t('operateSuccess'));
          reload();
        }} />
      ),
      row.can_reject_make_plate && (
        () => <RejectFormDialog data={row} rejectReasons={this.makePlateRejectReasons} submitHandler={async (value) => {
          await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/reject_make_plate`, value));
          this.$message.success(this.$t('operateSuccess'));
          reload();
        }} />
      ),
      row.can_reject_cut && (
        () => <RejectFormDialog data={row} rejectReasons={this.cutRejectReasons} submitHandler={async (value) => {
          await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/reject_cut`, value));
          this.$message.success(this.$t('operateSuccess'));
          reload();
        }} />
      ),
      row.can_reject_sew && (
        () => <RejectFormDialog data={row} rejectReasons={this.sewRejectReasons} submitHandler={async (value) => {
          await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/reject_sew`, value));
          this.$message.success(this.$t('operateSuccess'));
          reload();
        }} />
      ),
      abilities.reject_craft && (
        () => <RejectFormDialog data={row} rejectReasons={[]} submitHandler={async (value) => {
          await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/reject_craft`, value));
          this.$message.success(this.$t('operateSuccess'));
          reload();
        }} />
      ),
      abilities.reject_plate && (
        () => <RejectFormDialog data={row} rejectReasons={[]} submitHandler={async (value) => {
          await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/reject_plate`, value));
          this.$message.success(this.$t('operateSuccess'));
          reload();
        }} />
      ),
      abilities.create_product && {
        component: 'routeButton',
        props: {
          label: '创建商品',
          to: { name: 'products.new', query: { create_by_product_design_id: row.id } }
        }
      },
      abilities.submit_overdue_reason && {
        component: 'dialogFormButton',
        props: {
          label: '提交逾期原因',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'plan_completed_on',
              renderCell: {
                component: 'datePicker',
                required: true
              }
            },
            'overdue_reason',
            'plan_completed_remark',
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/submit_overdue_reason`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      abilities.destroy && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      row.can_cut && {
        component: 'dialogFormButton',
        props: {
          label: '剪版中',
          value: row,
          columns: formColumnsExtend([
            roleKind === 'cheif_pattern_making_officier' && {
              key: 'craftsman_id',
              renderCell: {
                required: true,
                props: {
                  clearable: true,
                  options: row.craftsman_id ? [{ label: row.craftsman.profile.name, value: row.craftsman_id }] : [],
                  xRemotePreload: async () => {
                    const { data } = await this.$request.get('/users/read_options', { per_page: 100, role_eq: 'craftsman', is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  },
                  xRemoteSearch: async (keyword) => {
                    const { data } = await this.$request.get('/users/read_options', { keyword, role_eq: 'craftsman', is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  }
                },
              }
            },
            'cut_remark',
            {
              prop: 'cut_remark_images',
              label: this.$t('productDesign.cutRemarkImages'),
              renderCell: {
                component: 'upload',
                props: {
                  limit: 9
                }
              }
            }
          ].filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/cut`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.can_sew && {
        component: 'dialogFormButton',
        props: {
          label: '车版中',
          value: row,
          columns: formColumnsExtend([
            roleKind === 'cheif_pattern_making_officier' && {
              key: 'sewer_id',
              renderCell: {
                required: true,
                props: {
                  clearable: true,
                  options: row.sew_id ? [{ label: row.sew.profile.name, value: row.sew_id }] : [],
                  xRemotePreload: async () => {
                    const { data } = await this.$request.get('/users/read_options', { per_page: 100, role_eq: 'sewer', is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  },
                  xRemoteSearch: async (keyword) => {
                    const { data } = await this.$request.get('/users/read_options', { keyword, role_eq: 'sewer', is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  }
                },
              }
            },
            'sewing_remark',
            {
              prop: 'sewing_remark_images',
              label: this.$t('productDesign.sewingRemarkImages'),
              renderCell: {
                component: 'upload',
                props: {
                  limit: 9
                }
              }
            }
          ].filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/sew`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.can_audit_quantity && {
        component: 'dialogFormButton',
        props: {
          label: '成本核价',
          value: row,
          columns: formColumnsExtend([
            'fabric_cost',
            'assist_cost',
            'craft_cost',
            'processing_cost',
            ...(row.management_cost ? ['management_cost'] : []),
            'fob_profit',
            'management_fee',
            'inspection_fee',
            'audit_quantity_remark',
          ].filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/audit_quantity`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      abilities.approve && row.plate_making_type === 'paper_pattern' && {
        component: 'dialogFormButton',
        props: {
          label: '同意',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'pattern_maker_id',
              renderCell: {
                required: true,
                props: this.usersSelectProps({ item: row.pattern_maker, query: { role_eq: 'pattern_maker' } })
              }
            }
          ].filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/approve`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      // 常规流程
      abilities.approve && row.plate_making_type !== 'paper_pattern' && row.pattern_factory === 'pattern' && {
        component: 'dialogFormButton',
        props: {
          label: '同意',
          value: row,
          columns: formColumnsExtend([
            row.state === 'pending' && {
              key: 'fabric_purchaser_id',
              hint: '如需采购面料，请选择采购员',
              renderCell: {
                component: 'select',
                props: this.usersSelectProps({ item: row.fabric_purchaser, query: { role_eq: 'purchaser' } })
              }
            },
            row.state === 'pending' && {
              key: 'purchaser_id',
              hint: '如需采购辅料，请选择采购员',
              renderCell: {
                component: 'select',
                props: this.usersSelectProps({ item: row.purchaser, query: { role_eq: 'purchaser' } })
              }
            },
            ['pending', 'make_plate_rejected'].includes(row.state) && {
              key: 'pattern_maker_id',
              renderCell: {
                required: true,
                props: {
                  clearable: true,
                  options: row.pattern_maker_id ? [{ label: row.pattern_maker.profile.name, value: row.pattern_maker_id }] : [],
                  xRemotePreload: async () => {
                    const { data } = await this.$request.get('/users/read_options', { per_page: 100, pattern_maker_with_product_design_id: row.id, is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  },
                  xRemoteSearch: async (keyword) => {
                    const { data } = await this.$request.get('/users/read_options', { keyword, pattern_maker_with_product_design_id: row.id, is_block_eq: false });
                    return data.map(item => ({ value: item.id, label: item.profile.name }));
                  }
                },
              }
            },
          ].filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/approve`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      // 供应商作为版房总监时的流程
      abilities.approve && row.plate_making_type !== 'paper_pattern' && row.pattern_factory !== 'pattern' && {
        component: 'confirmButton',
        props: {
          label: '同意',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/approve`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
    ].concat(_.map([
      { event: 'wait_for_confirm_fabric', label: '需要面料', columns: [{ prop: 'fabric_purchaser_id', label: this.$t('productDesign.fabricPurchaser'), renderCell: { component: 'select', required: true, props: this.usersSelectProps({ item: row.fabric_purchaser, query: { role_eq: 'purchaser' } }) } }] },
      { event: 'confirm_fabric', label: '确认面料', columns: ['confirm_fabric_remark', { prop: 'confirm_fabric_remark_images', label: this.$t('productDesign.confirmFabricRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
      { event: 'complete_fabric', label: '面料到位', columns: ['receive_fabric_remark', { prop: 'receive_fabric_remark_images', label: this.$t('productDesign.receiveFabricRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
      { event: 'update_confirm_fabric_remark', label: '更新面料确认备注', columns: ['confirm_fabric_remark', { prop: 'confirm_fabric_remark_images', label: this.$t('productDesign.confirmFabricRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
      { event: 'update_receive_fabric_remark', label: '更新面料到位备注', columns: ['receive_fabric_remark', { prop: 'receive_fabric_remark_images', label: this.$t('productDesign.receiveFabricRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
      { event: 'wait_for_confirm_accessory', label: '需要辅料', columns: [{ prop: 'purchaser_id', label: this.$t('productDesign.purchaser'), renderCell: { component: 'select', required: true, props: this.usersSelectProps({ item: row.purchaser, query: { role_eq: 'purchaser' } }) } }] },
      { event: 'confirm_accessory', label: '确认辅料', columns: ['confirm_accessory_remark', { prop: 'confirm_accessory_remark_images', label: this.$t('productDesign.confirmAccessoryRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
      { event: 'complete_accessory', label: '辅料到位', columns: ['receive_fabric_and_assist_remark', { prop: 'receive_fabric_and_assist_remark_images', label: this.$t('productDesign.receiveFabricAndAssistRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
      { event: 'update_confirm_accessory_remark', label: '更新辅料确认备注', columns: ['confirm_accessory_remark', { prop: 'confirm_accessory_remark_images', label: this.$t('productDesign.confirmAccessoryRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
      { event: 'update_receive_fabric_and_assist_remark', label: '更新辅料到位备注', columns: ['receive_fabric_and_assist_remark', { prop: 'receive_fabric_and_assist_remark_images', label: this.$t('productDesign.receiveFabricAndAssistRemarkImages'), renderCell: { component: 'upload', props: { limit: 9 } } } ] },
    ], (hash) => {
      return abilities[hash.event] && {
        component: 'dialogFormButton',
        props: {
          label: hash.label,
          value: row,
          columns: formColumnsExtend(hash.columns.filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/${hash.event}`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    })).concat(_.map([
      { event: 'approve_plate', label: '审版通过', remark_name: 'approve_plate_remark' },
    ], (hash) => {
      return abilities[hash.event] && {
        component: 'dialogFormButton',
        props: {
          label: hash.label,
          value: row,
          columns: formColumnsExtend([
            hash.remark_name,
            {
              prop: `${hash.remark_name}_images`,
              label: this.$t(`productDesign.${_.camelCase(`${hash.remark_name}Images`)}`),
              renderCell: {
                component: 'upload',
                props: {
                  limit: 9
                }
              }
            }
          ].filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/${hash.event}`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    })).concat(_.map([
      { event: 'make_plate', label: '制版中', remark_name: 'make_plate_remark' },
      { event: 'complete_make_plate', label: '完成制版', remark_name: 'complete_make_plate_remark' },
      { event: 'craft', label: '工艺进行中', remark_name: 'process_remark' },
      { event: 'complete_craft', label: '工艺完成', remark_name: 'complete_craft_remark' },
      { event: 'complete_sew', label: '车版完成', remark_name: 'complete_sewing_remark' },
    ], (hash) => {
      return row[`can_${hash.event}`] && {
        component: 'dialogFormButton',
        props: {
          label: hash.label,
          value: row,
          columns: formColumnsExtend([
            hash.remark_name,
            {
              prop: `${hash.remark_name}_images`,
              label: this.$t(`productDesign.${_.camelCase(`${hash.remark_name}Images`)}`),
              renderCell: {
                component: 'upload',
                props: {
                  limit: 9
                }
              }
            }
          ].filter(Boolean), { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/${hash.event}`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    })).concat(_.map([
      'make_plate_remark',
      'complete_make_plate_remark',
      'cut_remark',
      'process_remark',
      'complete_craft_remark',
      'sewing_remark',
      'complete_sewing_remark',
      'complete_sew',
      'approve_plate_remark',
    ], (remark_name) => {
      const label_i18n_key = `productDesign.${_.camelCase(remark_name)}`
      return row[`can_update_${remark_name}`] && {
        component: 'dialogFormButton',
        props: {
          label: `更新${this.$t(label_i18n_key)}`,
          value: row,
          columns: formColumnsExtend([
            remark_name,
            {
              prop: `${remark_name}_images`,
              label: this.$t(`productDesign.${_.camelCase(`${remark_name}Images`)}`),
              renderCell: {
                component: 'upload',
                props: {
                  limit: 9
                }
              }
            }
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/update_${remark_name}`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    })).concat(_.map([
      'audit_quantity_remark'
    ], (remark_name) => {
      const label_i18n_key = `productDesign.${_.camelCase(remark_name)}`
      return row[`can_update_${remark_name}`] && {
        component: 'dialogFormButton',
        props: {
          label: `更新${this.$t(label_i18n_key)}`,
          value: row,
          columns: formColumnsExtend([
            remark_name,
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/update_${remark_name}`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    })).concat(_.map([
      { event: 'make_plate_withdraw', label: '撤回制版中' },
      { event: 'complete_make_plate_withdraw', label: '撤回制版完成' },
      { event: 'cut_withdraw', label: '撤回剪版中' },
      { event: 'craft_withdraw', label: '撤回工艺进行中' },
      { event: 'complete_craft_withdraw', label: '撤回工艺完成' },
      { event: 'sew_withdraw', label: '撤回车版中' },
      { event: 'complete_sew_withdraw', label: '撤回车版完成' },
      { event: 'approve_plate_withdraw', label: '撤回审版通过' },
      { event: 'audit_quantity_withdraw', label: '撤回成本核价' },
      { event: 'sign_sample', label: '样版签收' },
      { event: 'sign_sample_withdraw', label: '撤回样版签收' },
    ], (hash) => {
      return abilities[hash.event] && {
        component: 'confirmButton',
        props: {
          label: hash.label,
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/product_designs/${row.id}/${hash.event}`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    })).concat([
      this.$refs.sourcePage.type === 'show' && row.files.length > 1 && {
        component: 'button',
        props: {
          label: '下载所有附件',
          type: 'primary',
        },
        on: {
          click: async () => {
            const zip = new JSZip();
            const options = { timeout: 30 * 60 * 1000, responseType: 'blob', return_res: true }
            await Promise.all(row.files.map(async item => {
              const { data } = await this.$request.get(item.url, {}, options);
              zip.file(item.filename, data, { binary: true });
            }));
            const content = await zip.generateAsync({ type: 'blob' });
            this.download(content, `制单-${row.number}-附件.zip`);
            this.$msgbox.alert('下载完成');
          }
        },
      },
      this.$refs.sourcePage.type === 'show' && row.orders_latest_ai_file_url && {
        component: 'button',
        props: {
          label: '下载订单AI文件',
          type: 'primary',
        },
        on: {
          click: async () => {
            window.open(row.orders_latest_ai_file_url, '_blank');
          }
        }
      }
    ])).filter(Boolean);
  }

  download(blob, fileName) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = window.URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
    document.body.removeChild(a);
  }

  async onFetchData({ type, resource }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get(`/${resource}`, { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/${resource}/${this.$route.params.id}`);
      this.record = data

      if (type === 'edit') {
        if (data.abilities.edit_company_id) {
          this.companies = (await this.$request.get('/companies/read_options', { users_pattern_factory_eq: data.pattern_factory })).data
        }
      } else {
        const { user } = await this.$request.get('mine');
        this.user = user;
      }

      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get('/product_designs/export', { ...this.$route.query });
      } else {
        await this.$request.get('/product_designs/export', { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success('文件正在导出，导出成功后将会发送到邮箱');
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}>导出</el-button>
    ];
  }
}

export const route = [
  {
    path: '/product_designs',
    name: 'product_designs.index',
    component: ProductDesigns,
    props: {
      type: 'index',
    }
  },
  {
    path: '/product_designs/new',
    name: 'product_designs.new',
    component: ProductDesigns,
    props: {
      type: 'new',
    }
  },
  {
    path: '/product_designs/:id',
    name: 'product_designs.show',
    component: ProductDesigns,
    props: {
      type: 'show',
    }
  },
  {
    path: '/product_designs/:id/edit',
    name: 'product_designs.edit',
    component: ProductDesigns,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style lang="scss" scoped>
/deep/ .admin-nest-form {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
